import { nanoid } from "nanoid";
import { debounce } from "./Debounce";
import { emitter } from "./Emitter";

function arrayRender<T extends object>(items: object[]): T[] {
    return items.map((item) => ({ ...item, _id: nanoid(10) } as T));
}

export { arrayRender, debounce, emitter };
